"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobilePlatformAdapter = void 0;
const PlatformDetector_1 = require("./PlatformDetector");
/**
 * Mobile (React Native) platform adapter for Firebase
 * Handles mobile-specific configuration and setup
 */
class MobilePlatformAdapter {
    detectPlatform() {
        return PlatformDetector_1.PlatformDetector.detect();
    }
    getConfig() {
        var _a;
        if (!PlatformDetector_1.PlatformDetector.isMobile()) {
            throw new Error('MobilePlatformAdapter can only be used in React Native environment');
        }
        try {
            // Try to load Expo constants
            let Constants;
            try {
                const expoConstants = 'expo-constants';
                Constants = require(expoConstants);
            }
            catch (expoError) {
                // Fallback to react-native-config if expo-constants isn't available
                try {
                    const reactNativeConfig = 'react-native-config';
                    const Config = require(reactNativeConfig);
                    const config = {
                        apiKey: Config.FIREBASE_API_KEY,
                        authDomain: `${Config.FIREBASE_PROJECT_ID}.firebaseapp.com`,
                        projectId: Config.FIREBASE_PROJECT_ID,
                        storageBucket: `${Config.FIREBASE_PROJECT_ID}.appspot.com`,
                        messagingSenderId: Config.FIREBASE_MESSAGING_SENDER_ID,
                        appId: Config.FIREBASE_APP_ID,
                        measurementId: Config.FIREBASE_MEASUREMENT_ID
                    };
                    return {
                        config,
                        useEmulators: false,
                        emulatorPorts: {}
                    };
                }
                catch (configError) {
                    throw new Error('Neither expo-constants nor react-native-config are available in React Native environment');
                }
            }
            const extra = ((_a = Constants.expoConfig) === null || _a === void 0 ? void 0 : _a.extra) || {};
            if (!extra.FIREBASE_PROJECT_ID) {
                throw new Error('Firebase configuration not found in Expo config');
            }
            const config = {
                apiKey: extra.FIREBASE_API_KEY,
                authDomain: `${extra.FIREBASE_PROJECT_ID}.firebaseapp.com`,
                projectId: extra.FIREBASE_PROJECT_ID,
                storageBucket: `${extra.FIREBASE_PROJECT_ID}.appspot.com`,
                messagingSenderId: extra.FIREBASE_MESSAGING_SENDER_ID,
                appId: extra.FIREBASE_APP_ID,
                measurementId: extra.FIREBASE_MEASUREMENT_ID
            };
            return {
                config,
                useEmulators: false,
                emulatorPorts: {}
            };
        }
        catch (error) {
            throw new Error(`Failed to load Firebase configuration for React Native: ${error}`);
        }
    }
    // Mobile doesn't typically use emulators, but we can add support later
    setupEmulators() {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('🔥 Emulator setup not implemented for mobile platform');
        });
    }
}
exports.MobilePlatformAdapter = MobilePlatformAdapter;
